export const MALE = 0;
export const FEMALE = 1;
export const OTHER = 2;

export const DISPLAY = 0;
export const UN_DISPLAY = 1;

export const DISPLAY_TAG = 1;
export const UN_DISPLAY_TAG = 0;

export const DISPLAY_INFO = 1;
export const UN_DISPLAY_INFO = 0;

export const READ_FLAG_READ = 1;
export const READ_FLAG_UN_READ = 0;

export const STATUS_CODE_SUCCESS = 0;
export const STATUS_CODE_ERROR = -1;

export const STEP_ONE = 1;
export const STEP_TWO = 2;
export const STEP_THREE = 3;
export const STEP_FOUR = 4;

export const LANG_JAPANESE = 1;
export const LANG_VIETNAMESE = 2;

export const LANG_CODE_JAPANESE = 'jp_en';
export const LANG_CODE_JAPANESE_LOWERCASE = 'jp_en';
export const LANG_CODE_JAPANESE_UPPERCASE = 'JP_EN';
export const LANG_CODE_VIETNAMESE = 'vn';
export const LANG_CODE_VIETNAMESE_LOWERCASE = 'vn';
export const LANG_CODE_VIETNAMESE_UPPERCASE = 'VN';
export const DEFAULT_LANGUAGE = LANG_JAPANESE;

export const LANG_JAPANESE_TITLE = '日本語/Eng';
export const LANG_VIETNAMESE_TITLE = 'Tiếng Việt';

export const MAX_PASSWORD_LENGTH = 12;
export const RESPONSE_STATUS_UNAUTHORIZED = 401;

export const WORK_STATUS_YES = 1; // have work experience
export const WORK_STATUS_NO = 2; // dont have work experience

export const PLAN_TO_RESIGN_STATUS = 4; // plan to resign
export const RESIGNED_STATUS = 3; // resigned

export const JAPANESE_COLOR_DEFAULT = '#E8320D';

export const JAPANESE_TEXT_COLOR_DEFAULT = '#FFFFFF';

export const FILTERED_BY_NEW = 1;
export const FILTERED_BY_VIEWED = 2;

// screen_log
export const TOP_SCREEN_ID = 'C1';
export const COMPANY_SCREEN_ID = 'C2';
export const SCOUT_SCREEN_ID = 'C3';
export const INTERVIEW_STATUS_SCREEN_ID = 'C5';
export const MY_CODE_SCREEN_ID = 'C6';
export const MY_PAGE_SCREEN_ID = 'C7';
export const ENTRY_INFORMATION_SCREEN_ID = 'C8';

// action_code
export const PAGE_VIEW = '1_PageView';
export const PLAY_VIDEO = '2_PlayYoutubeVideo';
export const UNPLAYED_VIDEO = 0;
export const PLAYED_VIDEO = 1;

// item per page in table
export const ITEM_PER_PAGE = 10;

// type notification
export const TYPE_INFORMATION = 1;
export const TYPE_NOTIFICATION = 2;

// publicize_flag in m_event
export const UN_PUBLIC_FLAG = 0;
export const PUBLIC_FLAG = 1;

// hint text date picker
export const HINT_TEXT_DATE_JAPANESE = 'YYYY/MM/DD';
export const HINT_TEXT_DATE_VIETNAMESE = 'DD/MM/YYYY';
export const HINT_TEXT_MONTH_JAPANESE = 'YYYY/MM';
export const HINT_TEXT_MONTH_VIETNAMESE = 'MM/YYYY';
// dd/mm/yyyy
export const REGEX_DATE_VIETNAMESE =
  '^([0-2][0-9]|(3)[0-1])(\\/)(((0)[0-9])|((1)[0-2]))(\\/)\\d{4}$';
export const REGEX_DATE_JAPANESE =
  '^(\\d{4})/(0?[1-9]|1[012])/(0?[1-9]|[12][0-9]|3[01])$';
// mm/yyyy
export const REGEX_MONTH_VIETNAMESE = '^(0[1-9]|1[0-2])\\/?([0-9]{4})$';
export const REGEX_MONTH_JAPANESE = '^(\\d{4})\\/(0[1-9]|1[0-2])$';

// other select value in (m_university, m_faculty)
export const OTHER_SELECT = '0';
export const OTHER_SELECT_TEXT_JP = 'その他 / Other';
export const OTHER_SELECT_TEXT_VN = 'Khác';

// type login (applicant-receptionist)
export const APPLICANT_TYPE_LOGIN = 0;
export const RECEPTIONIST_TYPE_LOGIN = 1;

// type display company
export const TYPE_GRID = 'TYPE_GRID';
export const TYPE_TABLE = 'TYPE_TABLE';

// check youtube link
export const YOUTUBE_LINK = 'https://www.youtube.com/';

// qrcode-action
export const QRSCAN_RECEPTION_CHECKIN_ACTION = 'receptionCheckInApplicant';
export const CHECKIN_RECEPTION_DATA_FORMAT = [
  'entry_no',
  'contract_id',
  'event_code'
];
export const QRSCAN_COMPANY_CHECKIN_ACTION = 'entryCheckInCompany';
export const CHECKIN_COMPANY_DATA_FORMAT = ['company_checkin_id'];
export const ERROR_QRCODE_COMPANY_MESSAGE_JP_EN =
  'QRコード、または会社コードは存在していません　/ QR code or company code is not valid';
export const ERROR_QRCODE_COMPANY_MESSAGE_VI =
  'QR code hoặc mã số công ty không tồn tại.';
export const ERROR_QRCODE_RECEPTIONIST_MESSAGE_JP_EN =
  'QRコード、またはエントリーコードは存在しません / QR code or entry code does not exist.';
export const ERROR_QRCODE_RECEPTIONIST_MESSAGE_VI =
  'QR code hoặc mã số ứng tuyển không hợp lệ.';

export const CHECKIN_SUCCESS_MESSAGE_VI = 'Bạn đã check in thành công';
export const CHECKIN_SUCCESS_MESSAGE_JP_EN =
  '受付完了しました　/ You have checked in successfully';

export const CHECKED_IN_COMPANY_MESSAGE_VI =
  'Bạn đã sử dụng mã trên để check in trước đó.';
export const CHECKED_IN_COMPANY_MESSAGE_JP_EN =
  '入力したコードは既に受付しました / You have already checked in using that code';
export const NOT_EXIST_COMPANY_MESSAGE_VI =
  'Mã QR hoặc mã số công ty không hợp lệ.';
export const NOT_EXIST_COMPANY_MESSAGE_JP_EN =
  'QRコード、または会社のコードは存在しません / QR code or company code does not exist.';

export const CHECKED_IN_RECEPTIONIST_MESSAGE_VI =
  'Ứng viên đã checkin trong ngày hôm nay.';
export const CHECKED_IN_RECEPTIONIST_MESSAGE_JP_EN =
  '本日はすでに受付済みです。/ This candidate has already checked in today.';
export const NOT_EXIST_RECEPTIONIST_MESSAGE_VI =
  'Mã QR hoặc mã số ứng viên không hợp lệ.';
export const NOT_EXIST_RECEPTIONIST_MESSAGE_JP_EN =
  'QRコード、またはエントリーコードは存在しません / QR code or entry code does not exist.';
export const NOT_CHECKED_IN_EVENT_MESSAGE_VI =
  'Bạn chưa tham gia check in sự kiện';
export const NOT_CHECKED_IN_EVENT_MESSAGE_JP_EN =
  'QRコード、またはエントリーコードは存在しません / You not check in receptionist';

export const TIME_ERROR_CHECK_IN_MESSAGE_VN =
  'Không thể check-in do sự kiện hiện không diễn ra';
export const TIME_ERROR_CHECK_IN_MESSAGE_JP_EN =
  'イベントの開催時間ではありません。/ The event is not opening now. Cannot check-in.';

export const CHECKED_IN = 'CHECKED';
export const INVALID_CHECK_IN = 'INVALID';
export const NOT_CHECKED_IN_EVENT = 'NOT_CHECKED_IN_EVENT';
export const TIME_ERROR_CHECK_IN = 'TIME_EVENT_ERROR';

// param japanese code
export const PARAM_JAPANESE_CODE = 'jp_en';

export const EVENT_DEFAULT = 'job_fair';
export const EVENT_SECOND_CAREER = 'second_career';
export const EVENT_BASIC_INFORMATION_FIELD = [
  {
    eventType: EVENT_DEFAULT,
    fields: [
      'img',
      'name',
      'gender',
      'birthday',
      'mail_address',
      're_mail_address',
      'phone_number',
      'address',
      'hometown_id',
      'facebook',
      'time_zone'
    ]
  },
  {
    eventType: EVENT_SECOND_CAREER,
    fields: [
      'name',
      'name_kana',
      'gender',
      'birthday',
      'mail_address',
      're_mail_address',
      'phone_number',
      'address',
      'hometown_id'
    ]
  }
];

export const EVENT_ENTRY_INFORMATION_FIELD = [
  {
    eventType: EVENT_DEFAULT,
    fields: [
      'study_status',
      'university_id',
      'school_name',
      'faculty_id',
      'faculty',
      'graduation_month',
      'work_status',
      'company_name',
      'industry_type',
      'occupation_type',
      'work_contract_type',
      'resignation_month',
      'jlpt_level',
      'english_level',
      'toeic_score',
      'skill_type',
      'expect_occupation_type',
      'work_location'
    ]
  },
  {
    eventType: EVENT_SECOND_CAREER,
    fields: [
      'last_academic_history',
      'work_status_text',
      'skill_name_text',
      'expect_occupation_type_text',
      'expected_requirements',
      'expected_pay',
      'any_additional_comments',
      'work_location'
    ]
  }
];

// end point
export const DOMAIN_NAME = 'https://jobfair.test';
export const ENTRY_ENDPOINT_NAME = 'entry';
export const RECEPTIONIST_ENDPOINT_NAME = 'receptionist';
export const LANDING_ENDPOINT_NAME = 'information';
export const TIME_ZONE_VN = '2';
export const TIME_ZONE_JP = '1';

// no room text
export const NO_ROOM_JP_EN = 'ルーム指定なし/No Room';

// no section text
export const NO_SECTION_JP_EN = 'セクション指定なし/No Section';

export const DISPLAY_INTERVIEW_SCHEDULE = 1;
export const UNDISPLAY_INTERVIEW_SCHEDULE = 0;
